export default __webpack_public_path__ + "static/media/matching-example-bg.c8c04852.svg";